import React from 'react';


interface RejectedTicket {
    ticket_number: string;
    producer: string;
    carrier: string;
    downloadURL: string;
}

interface RejectedTicketsModalProps {
    show: boolean;
    onHide: () => void;
    data: RejectedTicket[];
    onSelectTicket: (pdfUrl: string, index: number) => void;
}

export const RejectedTicketsModal: React.FC<RejectedTicketsModalProps> = ({
    show,
    onHide,
    data,
    onSelectTicket
}) => {
    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <button 
                        onClick={onHide} 
                        className="close-button"
                    >
                        Close
                    </button>
                    <h2 className="modal-title">Rejected Tickets List</h2>
                </div>
                <div className="modal-body-scrollable">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Ticket Number</th>
                                <th>Producer</th>
                                <th>Carrier</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index} onClick={() => onSelectTicket(item.downloadURL, index)} style={{ cursor: 'pointer' }}>
                                    <td>{item.ticket_number}</td>
                                    <td>{item.producer}</td>
                                    <td>{item.carrier}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
